export const defaultCoords = {
  a: [641.33,	 717.29],
  b: [828.77,	 630.00],
  c: [1007.40, 630.00],
  d: [1164.93, 757.59],
  e: [1268.94, 757.59],
  f: [1422.42, 880.96]
}

export const altPipingCoords = {
  'standaard': {
    a: [641.33,	 717.29],
    b: [828.77,	 630.00],
    c: [1007.40, 630.00],
    d: [1164.93, 757.59],
    e: [1268.94, 757.59],
    f: [1422.42, 880.96]
  },

  'variant-a': {
    a: [641.33,	 717.29],
    b: [885.77,	 600.00],
    c: [1064.40, 600.00],
    d: [1221.93, 727.59],
    e: [1384.1,  727.59],
    f: [1575.42, 880.96]
  },

 'variant-b': {
    a: [641.33,	 717.29],
    b: [885.77,	 600.00],
    c: [1064.40, 600.00],
    d: [1221.93, 727.59],
    e: [1325.9,  727.59],
    f: [1515.6,  880.96]
  }
}

export const defaultHeight = 450

export const taludMap = [
  calculateTaludFactor('a', 'b', 8),
  calculateTaludFactor('a', 'b', 6),
  calculateTaludFactor('a', 'b', 5),
]

export const taludInner = calculateTaludFactor('c', 'd', -6);

export function getPipingPolygonPoints (variant) {
  return [
    '394.721 880.964',
    '641.331 717.285',
    altPipingCoords[variant].b.join(' '),
    altPipingCoords[variant].c.join(' '),
    altPipingCoords[variant].d.join(' '),
    altPipingCoords[variant].e.join(' '),
    altPipingCoords[variant].f.join(' '),
    '394.721 880.964'
  ]
}

export function getPolygonPoints (factor = 1, talud = 1) {
  return [
    '394.721 880.964',
    '641.331 717.285',
    getCoords('b', factor, talud).join(' '),
    getCoords('c', factor, talud).join(' '),
    getCoords('d', factor, talud).join(' '),
    getCoords('e', factor, talud).join(' '),
    getCoords('f', factor, talud).join(' '),
    '394.721 880.964'
  ].join(',')
}

// Default 1:6
export function calculateTaludFactor (coord1, coord2, taludFactor = 6) {
  const x = defaultCoords[coord1][0] - defaultCoords[coord2][0]
  const y = defaultCoords[coord2][1] - defaultCoords[coord1][1]

  return ((y/x) / 6) * taludFactor;
}

export function baseHeight (factor) {
  return defaultHeight * factor
}

export function getX (coord, factor, talud) {
  switch (coord) {
    case 'b':
      return (-(getY(coord, factor, talud) - defaultCoords[coord][1]) * talud) + defaultCoords[coord][0]
    break;

    case 'c':
      return defaultCoords[coord][0] - defaultCoords.b[0] + getX('b', factor, talud)
    break;

    case 'd':
      return (-(getY('c', factor, talud) - defaultCoords.c[1]) * taludInner) + defaultCoords[coord][0] + (getX('c', factor, talud) - defaultCoords.c[0])
    break;

    case 'e':
      return defaultCoords[coord][0] - defaultCoords.d[0] + getX('d', factor, talud)
    break;

    case 'f':
      return defaultCoords[coord][0] - defaultCoords.e[0] + getX('e', factor, talud)
    break;

    default:
      break;
  }
}

export function getY (coord, factor, talud) {
  switch (coord) {
    case 'b':
      return defaultCoords[coord][1] - (baseHeight(factor) - defaultHeight)
    break;

    case 'c':
      return getY('b', factor, talud)
    break;

    case 'd':
      return defaultCoords[coord][1]
    break;

    case 'e':
      return defaultCoords[coord][1]
    break;

    case 'f':
      return defaultCoords[coord][1] - defaultCoords.e[1] + getY('e', factor, talud)
    break;

    default:
      break;
  }
}

export function getCoords (coord, factor = 1, talud = 1) {
  return [
    getX(coord, factor, taludMap[talud]),
    getY(coord, factor, taludMap[talud])
  ]
}